(function(){
'use strict';
var NAMESPACE='__PP_CART_FIX_V1';
if(window[NAMESPACE])return;
var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
root=root.replace(/\/?$/,'/');
var processing=false;
var api={busy:false};window[NAMESPACE]=api;
function drawerRoot(){return document.querySelector('cart-drawer');}
function isInsideDrawer(node){return !!(node&&node.closest&&node.closest('cart-drawer #CartDrawer-CartItems'));}
function getRow(el){return el&&el.closest&&el.closest('#CartDrawer-CartItems li[data-pp-line-key]');}
function errorFor(row,message){
 var el=row&&row.querySelector('.cart-item__error .cart-item__error-text');
 if(el){el.textContent=message||'';var box=el.closest('.cart-item__error');if(box)box.style.display=message?'block':'';}
 var msg=document.getElementById('CartDrawer-CartErrors');
 if(msg)msg.textContent=message||'';
}
function lock(row,flag){
 if(!row)return;
 row.setAttribute('aria-busy',flag?'true':'false');
 row.querySelectorAll('button,input').forEach(function(el){el.disabled=flag;});
}
async function jsonResponse(url,opts){
 var r=await fetch(url,opts),data;
 try{data=await r.json();}catch(e){data={};}
 if(!r.ok)throw new Error(data.description||data.message||'Shopify no pudo actualizar el carrito.');
 return data;
}
function reconcileRow(items,row){
 var key=row.getAttribute('data-pp-line-key');
 var variant=Number(row.getAttribute('data-pp-variant-id'));
 var index=Number(row.getAttribute('data-index'));
 var byKey=items.find(function(x){return x.key===key;});
 if(byKey)return byKey;
 if(index>=1 && index<=items.length && Number(items[index-1].variant_id)===variant)return items[index-1];
 var matches=items.filter(function(x){return Number(x.variant_id)===variant;});
 if(matches.length===1)return matches[0];
 throw new Error('No pude identificar esta talla de forma segura. Recarga el carrito e inténtalo otra vez.');
}
async function reloadCartMarkup(){
 var sections=await jsonResponse(root+'?sections=cart-drawer,cart-icon-bubble',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
 var drawer=drawerRoot();
 if(!drawer||!sections['cart-drawer'])throw new Error('La sección del carrito no está disponible.');
 var doc=new DOMParser().parseFromString(sections['cart-drawer'],'text/html');
 var next=doc.querySelector('#CartDrawer');
 var current=drawer.querySelector('#CartDrawer');
 if(!next||!current)throw new Error('La respuesta del carrito no contiene los artículos.');
 var body=current.querySelector('.cart-drawer__body');
 var scrollTop=body?body.scrollTop:0;
 current.replaceWith(next);
 var newBody=next.querySelector('.cart-drawer__body');
 if(newBody)newBody.scrollTop=Math.min(scrollTop,newBody.scrollHeight);
 var iconHtml=sections['cart-icon-bubble'];
 if(iconHtml){var iconDoc=new DOMParser().parseFromString(iconHtml,'text/html');var newIcon=iconDoc.querySelector('#cart-icon-bubble');var oldIcon=document.getElementById('cart-icon-bubble');if(newIcon&&oldIcon)oldIcon.replaceWith(newIcon);}
 if(typeof drawer.renderContents==='function'){
  // DOM already refreshed from Shopify server response, no extra rerender.
 }
 document.dispatchEvent(new Event('cart:updated',{bubbles:true}));
 if(window.__PP_REWARDS_CART_V4 && window.__PP_REWARDS_CART_V4.schedule)window.__PP_REWARDS_CART_V4.schedule(120);
 if(window.__PP_HAT_OFFER_V1 && window.__PP_HAT_OFFER_V1.refresh)window.__PP_HAT_OFFER_V1.refresh();
}
async function change(row,qty){
 if(processing)return;
 processing=true;api.busy=true;
 errorFor(row,'');lock(row,true);
 try{
  // Never submit numeric line indices: Shopify line keys survive multiple sizes.
  var snapshot=await jsonResponse(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
  var found=reconcileRow(snapshot.items||[],row);
  var count=Math.max(0,Math.trunc(Number(qty)));
  if(!Number.isFinite(count))throw new Error('Cantidad incorrecta.');
  await jsonResponse(root+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:found.key,quantity:count})});
  try{await reloadCartMarkup();}
  catch(refreshError){window.location.reload();}
 }catch(e){
  errorFor(row,e.message||'Error al modificar el carrito.');
  lock(row,false);
  var input=row&&row.querySelector('input.quantity__input');
  if(input){try{var cart=await jsonResponse(root+'cart.js',{credentials:'same-origin',cache:'no-store'});var line=reconcileRow(cart.items||[],row);input.value=line.quantity;}catch(_e){}}
 }finally{processing=false;api.busy=false;}
}
// Capture phase: this runs BEFORE Shrine's cart-remove-button and cart-drawer-items listeners.
document.addEventListener('click',function(ev){
 var remove=ev.target.closest&&ev.target.closest('cart-remove-button');
 if(!remove||!isInsideDrawer(remove))return;
 var row=getRow(remove);
 if(!row)return;
 ev.preventDefault();ev.stopImmediatePropagation();ev.stopPropagation();
 if(!processing)change(row,0);
},true);
document.addEventListener('change',function(ev){
 var field=ev.target;
 if(!field||!field.matches||!field.matches('#CartDrawer-CartItems input.quantity__input'))return;
 var row=getRow(field);if(!row)return;
 ev.preventDefault();ev.stopImmediatePropagation();ev.stopPropagation();
 if(!processing)change(row,field.value);
},true);
// Persist across redraws: delegated events bound once to document.
})();